import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, Divider, HStack, Heading, Icon, IconButton, Modal as ChakraModal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage, useIntl } from 'react-intl';
export default function Modal(param) {
    var title = param.title, isOpen = param.isOpen, _param_canConfirm = param.canConfirm, canConfirm = _param_canConfirm === void 0 ? true : _param_canConfirm, confirmText = param.confirmText, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, children = param.children, onConfirm = param.onConfirm, onClose = param.onClose;
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(ChakraModal, {
        isOpen: isOpen,
        onClose: onClose,
        isCentered: true,
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsx(ModalContent, {
                bgColor: "backgroundPrimary",
                children: /*#__PURE__*/ _jsxs(ModalBody, {
                    p: 0,
                    children: [
                        /*#__PURE__*/ _jsxs(HStack, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 6,
                            py: 4,
                            children: [
                                /*#__PURE__*/ _jsx(Heading, {
                                    size: "md",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(IconButton, {
                                    variant: "ghost",
                                    size: "sm",
                                    "aria-label": intl.formatMessage({
                                        id: "rbrahO",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Close"
                                            }
                                        ]
                                    }),
                                    icon: /*#__PURE__*/ _jsx(Icon, {
                                        as: FontAwesomeIcon,
                                        icon: faClose
                                    }),
                                    onClick: onClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Divider, {
                            borderColor: "borderSecondary"
                        }),
                        children,
                        /*#__PURE__*/ _jsx(Divider, {
                            borderColor: "borderSecondary"
                        }),
                        /*#__PURE__*/ _jsxs(HStack, {
                            spacing: 6,
                            p: 6,
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    isDisabled: loading,
                                    onClick: onClose,
                                    flex: 1,
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "47FYwb",
                                        defaultMessage: "Cancel"
                                    })
                                }),
                                onConfirm != null ? /*#__PURE__*/ _jsx(Button, {
                                    flex: 1,
                                    variant: "cta",
                                    isLoading: loading,
                                    onClick: onConfirm,
                                    isDisabled: !canConfirm,
                                    children: confirmText
                                }) : null
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
